class Base extends PIXI.Sprite {
	constructor() {
		super(Assets.allTowers[0].baseTex);
		this.anchor.set(0.5);
		this.interactive = true;
		this.on('pointerdown', this.clicked);
	}

	building: Building = null;

	clicked = (event: PIXI.interaction.InteractionEvent) => {
		if (event) {
			event.stopPropagation();
		}
		if (this.checkTutor()) {
			return;
		}
		if (!this.building) {
			Interact.shopTower.show(this);
		} else {
			Interact.shopRepair.show(this);
		}
	};

	spawnBuilding(type: number) {
		if (this.building) return;
		let dicts = Game.dicts;

		let map: Array<MobDict> = [
			dicts.defence,
			dicts.machineGun,
			dicts.machineGun,
			dicts.sniper,
			dicts.mortar
		];

		let tower = new Tower(Assets.allTowers[type], map[type]);
		tower.position.copy(this.position);
		Game.buildingsContainer.addChild(tower);
		Game.worldController.addActor(tower);

		this.building = tower;

		// this.interactive = false;
	}

	spawn(pair: ITowerPair) {
		if (this.building) return;
		let tower = new Tower(pair.skin, pair.dict);
		Game.statBar.money += tower.price;
		tower.position.copy(this.position);
		Game.buildingsContainer.addChild(tower);
		Game.worldController.addActor(tower);

		this.building = tower;
	}

	upgrade() {
		// nothing
		const bld = this.building as Tower;
		if (!bld) return;
		if (!bld.desc) return;

		let oldSkin = bld.desc;
		let oldDict = (bld as any).dict;

		Game.buildingsContainer.removeChild(bld);
		Game.worldController.removeActor(bld);
		this.building = null;

		oldDict = Upgrades.getUpgradeDict(oldDict);
		if (oldSkin === Assets.allTowers[1]) {
			oldSkin = Assets.allTowers[2];
		}
		this.spawn({skin: oldSkin, dict: oldDict});
	}

	repair() {
		const bld = this.building;
		if (!bld) return;
		bld.health = bld.healthMax;
		Game.statBar.money += (bld.price / 2) | 0;
	}

	update(delta: number) {
		if (this.building) {
			if (this.building.zombie) {
				this.building = null;
				//building died, base is online again
			}
		}
	}

	tutored: boolean = false;
	checkTutor(): boolean {
		if (Tutorial.active) {
			if (this.tutored) {
				if (!this.building) {
					Interact.shopTower.show(this);
				} else {
					Interact.shopRepair.show(this);
				}
				this.tutored = false;
				Tutorial.next();
			} else {
				return true;
				// Tutorial.end();
			}
		}
		return false;
	}
}
